import { AppStateSlice } from '$tablet-app/src/app/stores/app_state';
import { appendArray } from '@akin-home/arrays';
import { ChatItem, ChatItemTypes } from '../../ChatItem/types';
import { isOutputChatItem } from './../../functions';
import { ChatLogStore } from './types';

interface ChatUpdateObject {
  chat_items: ChatItem[];
  displayed_chat_item_idx?: number;
  displayed_dynamic_chat_item?: ChatItem;
}

/** This store contains the chat log, and functions for modifying the chat log */
export const creatChatLogStore: AppStateSlice<ChatLogStore> = (set, get) => ({
  chat_items: [],
  addChatItem(items) {
    const { chat_items, chat_dialog_visible } = get();

    const items_array = Array.isArray(items) ? items : [items];
    const new_chat_items = appendArray(chat_items, items_array);

    const update: ChatUpdateObject = {
      chat_items: new_chat_items,
    };

    if (!chat_dialog_visible) {
      /** Get the index of the item we want to display */

      const idx = items_array.findIndex((item) => isOutputChatItem(item));

      // Calculate the idx in the full chat list
      update.displayed_chat_item_idx =
        new_chat_items.length - items_array.length + idx;

      update.displayed_dynamic_chat_item = items_array.find((item) =>
        showInDialog(item.type)
      );
    }

    const last_item = items_array[0];

    if (isOutputChatItem(last_item)) {
      get().speakIfEnabled(last_item.data.text);
    }

    set(update);
  },
  clearChat() {
    set({ chat_items: [] });
  },
  modifyLastItemResponse(newResponseStr: string) {
    set((state) => {
      const last_item = state.chat_items.slice(-1)[0];
      if (isOutputChatItem(last_item)) {
        last_item.data.text = newResponseStr;
      }
    });
  },
});

const showInDialog = (type?: ChatItemTypes) =>
  !!type &&
  [
    ChatItemTypes.CALENDAR_ITEM,
    ChatItemTypes.CLOCK,
    ChatItemTypes.WEATHER,
    ChatItemTypes.RECIPE_ITEM,
    ChatItemTypes.CHECKLIST,
  ].includes(type);
